// Cart changes for Amplify


document.addEventListener('DOMContentLoaded', function() {
    function onPickyCartLoaded(){
        const poweredByElement = document.querySelector('.picky-powered-by');
        const paymentMethodsElement = document.querySelector('.footer__payment-icons');
        if(paymentMethodsElement){
            const paymentMethodsElementClone = paymentMethodsElement.cloneNode(true);

            // Overwrite the element powered by with the payment methods and adjust styles
            poweredByElement.parentElement.replaceChild(paymentMethodsElementClone, poweredByElement);
            paymentMethodsElementClone.style.gap = '0';
            paymentMethodsElementClone.style.justifyContent = 'space-between';
        }
    }

    //listen for changes on the body element and detect if a ".picky-cart" element is added once
    const observer = new MutationObserver(function(mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('picky-cart')) {
                        // It is loaded twice so we have to check the content
                        // stop observing if picky-cart contains .picky-powered-by
                        if (node.querySelector('.picky-powered-by')) {
                            observer.disconnect();
                            onPickyCartLoaded();
                        }
                    }
                });
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});
